//
//
//
//
//
//
//
//
//
//
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
export default {
  components: {
    CommonTitle: CommonTitle
  },
  computed: {
    list: function list() {
      return window.setting.广告位;
    }
  }
};